/**
 * programmiCorsi.js — programma didattico ufficiale di ogni corso.
 *
 * Contenuti minimi stabiliti dalla normativa (D.Lgs. 81/2008, Accordo
 * Stato-Regioni 2025): sono gli stessi per ogni ente. Importati il 18/09/2026.
 */

export const programmi = {
  "formazione-generale-lavoratori-4h": [
    "FORMAZIONE GENERALE",
    "concetti di pericolo, rischio e danno, prevenzione e protezione",
    "organizzazione della prevenzione aziendale e il sistema di partecipazione dei lavoratori e dei loro rappresentanti previsto dal D. Lgs. 81 del 2008;",
    "diritti, doveri e sanzioni per i vari soggetti aziendali;",
    "organi di vigilanza, controllo e assistenza"
  ],
  "aggiornamento-lavoratori-tutti-rischi-6h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Approfondimento Normativi e Giuridici: Evoluzione del sistema normativo e novità legislative. Obblighi e responsabilità dei soggetti coinvolti (datore di lavoro, preposto, lavoratori). Approfondimenti sull'Accordo Stato-Regioni. Approfondimento Rischi Tecnici e Specifici Panoramica e aggiornamento sui rischi (meccanici, elettrici, chimici, biologici, fisici).Movimentazione manuale carichi, ergonomia, videoterminali. Rischio infortuni e near-miss (quasi infortuni).Rischi legati all'organizzazione del lavoro e al contesto lavorativo. Gestione della Sicurezza e Procedure Misure di prevenzione e protezione aggiornate. Utilizzo corretto dei DPI (Dispositivi di Protezione Individuale). Procedure di esodo, antincendio e primo soccorso. Segnaletica di sicurezza."
  ],
  "formazione-specifica-rischio-basso-4h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Rischi Generali e Meccanici; Rischi infortuni e rischi meccanici generali; Rischi elettrici generali;",
    "Macchine e Attrezzature; Cadute dall'alto; Rischi da esplosione; Rischi Chimici e Fisici; Rischi chimici (nebbie, oli, fumi, vapori, polveri, etichettatura, schede di sicurezza); Rischi cancerogeni e biologici;",
    "Rischi fisici (rumore, vibrazioni, radiazioni ottiche artificiali - ROA, campi elettromagnetici - CEM, microclima e illuminazione); Organizzazione, Movimentazione e DPI; Organizzazione del lavoro e ambienti di lavoro; Stress lavoro-correlato; Movimentazione manuale dei carichi; Movimentazione merci (apparecchi di sollevamento, mezzi di trasporto); Videoterminalisti e ergonomia; Uso corretto dei Dispositivi di Protezione Individuale (DPI)e Dispositivi di Protezione Collettiva (DPC); Procedure di Emergenza e Sicurezza; Segnaletica di sicurezza Procedure di emergenza ed esodo; Procedure antincendio e primo soccorso; Incidenti e infortuni mancati; Alcool, droghe e lavoro; Misure e Procedure di Prevenzione e Protezione sulla mansione e nel settore o comparto di appartenenza dell’Azienda.",
    "Test di Verifica Finale Corso di Formazione Specifica dei Lavoratori - Rischio Basso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-rls-fino-50-4h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Introduzione al corso",
    "- Gestione della Comunicazione nelle diverse situazioni di lavoro",
    "- Infortuni e Near Miss",
    "- Il Rischio di Stress da Lavoro Correlato",
    "- Trattazione di tematiche legate alla Gestione delle Emergenze",
    "- Trattazione di tematiche legate ai rischi specifici inerenti l'attività lavorativa ed analisi di sentenze in materia",
    "Test di Verifica Finale Corso Aggiornamento RLS",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "rspp-aspp-modulo-a-28h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "UNITÀ DIDATTICA A1 - 8 ORE",
    "- Presentazione e apertura del corso",
    "- L'approccio alla prevenzione nel d.lgs. n. 81/2008",
    "- Il sistema legislativo: esame delle normative di riferimento",
    "- Il sistema istituzionale della prevenzione",
    "- Il sistema di vigilanza e assistenza",
    "UNITÀ DIDATTICA A2 - 4 ORE",
    "- I soggetti del sistema di prevenzione aziendale secondo il d.lgs. n. 81/2008",
    "UNITÀ DIDATTICA A3 - 8 ORE",
    "- Il processo di valutazione dei rischi",
    "UNITÀ DIDATTICA A4 - 4 ORE",
    "- Le ricadute applicative e organizzative della valutazione dei rischi",
    "- La gestione delle emergenze",
    "- La sorveglianza sanitaria",
    "UNITÀ DIDATTICA A5 - 4 ore",
    "- Gli istituti relazionali: informazione, formazione, addestramento, consultazione e partecipazione"
  ],
  "aggiornamento-dirigenti-6h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "AGGIORNAMENTO SU:",
    "- Il Sistema Legislativo dalla 626 alla 81",
    "- Soggetti della Sicurezza: compiti, obblighi e responsabilità e tutela assicurativa",
    "- La Delega di Funzioni",
    "- La Responsabilità civile e penale e la tutela assicurativa",
    "- La responsabilità amministrativa (D. Lgs. n. 231/2001)",
    "- Sistemi di qualificazione delle imprese",
    "- Sistema pubblico  di prevenzione",
    "- Modelli di organizzazione e Gestione",
    "- Organizzazione tecnico amministrativa",
    "- Gestione delle emergenze",
    "- Vigilanza e dirigenti",
    "- RSPP",
    "- Percezione del rischio",
    "- Stress da lavoro correlato",
    "- Valutazione dei rischi",
    "- DUVRI",
    "- Misure tecniche procedurali",
    "- Infortuni e infortuni mancati",
    "- DPI",
    "- Sorveglianza sanitaria",
    "- Dirigente",
    "- Informazione formazione e addestramento",
    "- Comunicazione",
    "- Dinamiche di gruppo",
    "- RLS nomina, elezioni",
    "- Consultazione e partecipazione RLS",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "rspp-datore-lavoro-8h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Accordo Stato-Regioni del 7 luglio 2016: formazione per la tutela della sicurezza e salute sul lavoro per dirigenti, preposti e lavoratori;",
    "- Principi giuridici ed evoluzione della legislazione, con breve analisi della Costituzione, del Codice Civile e del Codice Penale; il sistema legislativo in materia di sicurezza dei lavoratori; la responsabilità civile e penale;",
    "- Decreto Legislativo 81/2008 e le misure di prevenzione e protezione;",
    "- Decreto Legislativo 231/2001: i principi della responsabilità amministrativa delle società;",
    "- Gli attori del sistema di prevenzione aziendale secondo il D.Lgs. 81/08: compiti, obblighi, responsabilità; la considerazione delle risultanze delle attività di partecipazione dei lavoratori;",
    "- Il Sistema istituzionale della prevenzione; la tutela assicurativa.",
    "- Criteri e strumenti per l'individuazione e la valutazione dei rischi; il documento di valutazione dei rischi (contenuti, specificità e metodologie); la gestione della documentazione tecnico amministrativa;",
    "- Gli incidenti e gli infortuni mancati;",
    "- Sistemi di Gestione della Sicurezza nei Luoghi di Lavoro;",
    "- Gestione della sicurezza nei contratti d'appalto; il sistema di qualificazione delle imprese; il documento unico di valutazione dei rischi da interferenza.",
    "- Accordi Stato-Regioni 2011: la formazione per la tutela della sicurezza e salute sul lavoro per i dirigenti, i preposti ed i lavoratori; la formazione dei datori di lavoro RSPP.",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-csp-cse-40h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Alcuni richiami della legislazione in materia di Titolo IV – D.lgs 81/2008",
    "- La definizione di “cantiere”: giurisprudenza",
    "- L’Impresa affidataria: obblighi di verifica nei cantieri",
    "- Lo “Statuto funzionale del CSE”: strategie operative e responsabilità",
    "- Il ruolo e la funzione del R.U.P negli appalti pubblici",
    "- Giurisprudenza commentata",
    "- La definizione di «comunicazione»",
    "- Il ruolo dei «bisogni» e la piramide di Maslow",
    "- I «canali» della comunicazione",
    "- Gli «assiomi» della comunicazione",
    "- Comunicazione efficace e lavoro: assertività e gestione dei conflitti",
    "- Principali disposizioni legislative e normative",
    "- Effetti dell’elettricità sul corpo umano e sistemi di prevenzione e protezione",
    "- Valutazione dei rischi (cenni su POS e PSC)",
    "- MMC",
    "- Rischi fisici",
    "- Rischi chimici e biologici",
    "- Il metodo B-BS",
    "- La scienza del comportamento: principi fondamentali",
    "- Comportamenti di sicurezza più difficili da adottare",
    "- Attrezzatura e DPI per lavori elettrici",
    "- Valutazione dei rischi e delle condizioni ambientali",
    "- Preparazione dei lavori elettrici",
    "- Lavoro su impianti",
    "- Analizzare le motivazioni dei comportamenti: il metodo «pic-nic»",
    "- Orientare i comportamenti: schemi di rinforzo e feed-back",
    "- L’applicazione del modello in una situazione reale",
    "- Cenni di prevenzione incendi",
    "- Mezzi di estinzione utilizzabili in cantiere",
    "- Ruoli e profili professionali",
    "- Comunicazioni e documentazione per lavori elettrici",
    "- Lavori fuori tensione",
    "- Lavori sotto tensione in bassa tensione",
    "- Movimento terra, scavi e rischio di seppellimento",
    "- Rischio di annegamento",
    "- Lavori in elevazione e rischi di caduta nel vuoto e taglio di alberi",
    "- Fase operativa del cantiere",
    "- Mezzi di estinzione",
    "- Fase latente non operativa del cantiere",
    "- Lavori in prossimità di parti attive",
    "- Lavori non elettrici",
    "- Segnaletica di sicurezza",
    "- Segnaletica dei cantieri stradali",
    "- Il nuovo approccio",
    "- Le Direttive di prodotto",
    "- Norme armonizzate",
    "- Valutazione rischio macchine",
    "- Decreto 758 sanzioni (cenni)",
    "- DPI connessi ai rischi specifici di mansione",
    "- Check list di verifica di cantiere",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "rls-32h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Gli aspetti generali del D.Lgs. 81/2008",
    "- Dalle direttive europee ai Decreti Legislativi",
    "- Legislazione generale in materia di sicurezza",
    "- I soggetti coinvolti nella prevenzione (dal datore di lavoro ai lavoratori)",
    "- Ruolo della medicina del lavoro nella sicurezza",
    "- L’igiene e la sicurezza sul luogo di lavoro",
    "- La prevenzione sul lavoro e Registro Infortuni",
    "- La sorveglianza sanitaria ed il medico competente",
    "- Definizione del concetto di rischio",
    "- Individuazione dei fattori di rischio",
    "- La prevenzione",
    "- La valutazione del rischio",
    "- La rilevazione del rischio",
    "- Rischio chimico, fisico, biologico",
    "- Le misure di prevenzione nel Documento di Valutazione",
    "- L’elaborazione del Documento di Valutazione",
    "- Classificazione dei fattori di rischio",
    "- Il ciclo produttivo e la rilevazione dei rischi",
    "- Le modifiche, aggiornamenti, valutazione, ed applicazione del Documento di Valutazione",
    "- Aspetti organizzativi",
    "- Pronto soccorso, antincendio, evacuazione emergenza",
    "- Dispositivi di Protezione Individuale e Collettivi",
    "- Il Rappresentante dei Lavoratori e la sicurezza",
    "- Il RLS ed il sindacato",
    "- Compiti e funzioni del RLS",
    "- Le specificità dell’Ente Bilaterale in relazione al processo delle relazioni interne",
    "- Nozioni e tecnica della comunicazione",
    "- La comunicazione interpersonale",
    "- Il coinvolgimento del RSL nella verifica del Documento di Valutazione",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-lavoratori-rischio-medio-6h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Approfondimento Normativi e Giuridici: Evoluzione del sistema normativo e novità legislative. Obblighi e responsabilità dei soggetti coinvolti (datore di lavoro, preposto, lavoratori). Approfondimenti sull'Accordo Stato-Regioni. Approfondimento Rischi Tecnici e Specifici Panoramica e aggiornamento sui rischi (meccanici, elettrici, chimici, biologici, fisici).Movimentazione manuale carichi, ergonomia, videoterminali. Rischio infortuni e near-miss (quasi infortuni).Rischi legati all'organizzazione del lavoro e al contesto lavorativo. Gestione della Sicurezza e Procedure Misure di prevenzione e protezione aggiornate. Utilizzo corretto dei DPI (Dispositivi di Protezione Individuale). Procedure di esodo, antincendio e primo soccorso. Segnaletica di sicurezza."
  ],
  "aggiornamento-rls-oltre-50-8h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "ASPETTI NORMATIVI DELL’ATTIVITÀ DI RAPPRESENTANZA DEI LAVORATORI",
    "- Il Rappresentante dei Lavoratori e la sicurezza",
    "- Il RLS ed il sindacato",
    "- La partecipazione dei lavoratori",
    "- Compiti, ruolo ed adempimenti del RLS",
    "- La riunione periodica",
    "NOZIONI DI TECNICA DELLA COMUNICAZIONE",
    "- Nozioni e tecnica della comunicazione",
    "- La comunicazione interpersonale",
    "I RISCHI PSICO-SOCIALI E LO STRESS LAVORO-CORRELATO",
    "- Mobbing",
    "- Burn-out",
    "- Stress lavoro-correlato",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "coordinatore-modulo-giuridico-8h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Il Decreto 81/08 in materia di salute e sicurezza nei luoghi di lavoro.",
    "- I soggetti del Sistema di Prevenzione Aziendale: i compiti, gli obblighi, le responsabilità civili e penali",
    "- La legislazione specifica in materia di salute e sicurezza nei cantieri temporanei o mobili e nei lavori in quota. (Il Titolo IV del nuovo DLgs 81/08 in materia di salute e sicurezza nei luoghi di lavoro)",
    "- Attrezzature da lavoro",
    "- Attrezzature esplosive",
    "- Spazi Confinanti",
    "- Pes Pav Pei - Concetti generali",
    "- Sistemi di Gestione della Sicurezza",
    "- D.Lgs. 231",
    "- SPP organizzare servizio interno ed esterno",
    "- Sistema delle relazioni e della comunicazione",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-formatori-24h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Alcuni richiami della legislazione in materia di Titolo IV – D.lgs 81/2008",
    "- La definizione di “cantiere”: giurisprudenza",
    "- L’Impresa affidataria: obblighi di verifica nei cantieri",
    "- Lo “Statuto funzionale del CSE”: strategie operative e responsabilità",
    "- Il ruolo e la funzione del R.U.P negli appalti pubblici",
    "- Giurisprudenza commentata",
    "- La definizione di «comunicazione»",
    "- Il ruolo dei «bisogni» e la piramide di Maslow",
    "- I «canali» della comunicazione",
    "- Gli «assiomi» della comunicazione",
    "- Comunicazione efficace e lavoro: assertività e gestione dei conflitti",
    "- Principali disposizioni legislative e normative",
    "- Effetti dell’elettricità sul corpo umano e sistemi di prevenzione e protezione",
    "- Valutazione dei rischi (cenni su POS e PSC)",
    "- MMC",
    "- Rischi fisici",
    "- Rischi chimici e biologici",
    "- Il metodo B-BS",
    "- La scienza del comportamento: principi fondamentali",
    "- Comportamenti di sicurezza più difficili da adottare",
    "- Attrezzatura e DPI per lavori elettrici",
    "- Valutazione dei rischi e delle condizioni ambientali",
    "- Preparazione dei lavori elettrici",
    "- Lavoro su impianti",
    "- Analizzare le motivazioni dei comportamenti: il metodo «pic-nic»",
    "- Orientare i comportamenti: schemi di rinforzo e feed-back",
    "- L’applicazione del modello in una situazione reale",
    "- Cenni di prevenzione incendi",
    "- Mezzi di estinzione utilizzabili in cantiere",
    "- Ruoli e profili professionali",
    "- Comunicazioni e documentazione per lavori elettrici",
    "- Lavori fuori tensione",
    "- Lavori sotto tensione in bassa tensione",
    "- Movimento terra, scavi e rischio di seppellimento",
    "- Rischio di annegamento",
    "- Lavori in elevazione e rischi di caduta nel vuoto e taglio di alberi",
    "- Fase operativa del cantiere",
    "- Mezzi di estinzione",
    "- Fase latente non operativa del cantiere",
    "- Lavori in prossimità di parti attive",
    "- Lavori non elettrici",
    "- Segnaletica di sicurezza",
    "- Segnaletica dei cantieri stradali",
    "- Il nuovo approccio",
    "- Le Direttive di prodotto",
    "- Norme armonizzate",
    "- Valutazione rischio macchine",
    "- Decreto 758 sanzioni (cenni)",
    "- DPI connessi ai rischi specifici di mansione",
    "- Check list di verifica di cantiere",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-rspp-40h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Alcuni richiami della legislazione in materia di Titolo IV – D.lgs 81/2008",
    "- La definizione di “cantiere”: giurisprudenza",
    "- L’Impresa affidataria: obblighi di verifica nei cantieri",
    "- Lo “Statuto funzionale del CSE”: strategie operative e responsabilità",
    "- Il ruolo e la funzione del R.U.P negli appalti pubblici",
    "- Giurisprudenza commentata",
    "- La definizione di «comunicazione»",
    "- Il ruolo dei «bisogni» e la piramide di Maslow",
    "- I «canali» della comunicazione",
    "- Gli «assiomi» della comunicazione",
    "- Comunicazione efficace e lavoro: assertività e gestione dei conflitti",
    "- Principali disposizioni legislative e normative",
    "- Effetti dell’elettricità sul corpo umano e sistemi di prevenzione e protezione",
    "- Valutazione dei rischi (cenni su POS e PSC)",
    "- MMC",
    "- Rischi fisici",
    "- Rischi chimici e biologici",
    "- Il metodo B-BS",
    "- La scienza del comportamento: principi fondamentali",
    "- Comportamenti di sicurezza più difficili da adottare",
    "- Attrezzatura e DPI per lavori elettrici",
    "- Valutazione dei rischi e delle condizioni ambientali",
    "- Preparazione dei lavori elettrici",
    "- Lavoro su impianti",
    "- Analizzare le motivazioni dei comportamenti: il metodo «pic-nic»",
    "- Orientare i comportamenti: schemi di rinforzo e feed-back",
    "- L’applicazione del modello in una situazione reale",
    "- Cenni di prevenzione incendi",
    "- Mezzi di estinzione utilizzabili in cantiere",
    "- Ruoli e profili professionali",
    "- Comunicazioni e documentazione per lavori elettrici",
    "- Lavori fuori tensione",
    "- Lavori sotto tensione in bassa tensione",
    "- Movimento terra, scavi e rischio di seppellimento",
    "- Rischio di annegamento",
    "- Lavori in elevazione e rischi di caduta nel vuoto e taglio di alberi",
    "- Fase operativa del cantiere",
    "- Mezzi di estinzione",
    "- Fase latente non operativa del cantiere",
    "- Lavori in prossimità di parti attive",
    "- Lavori non elettrici",
    "- Segnaletica di sicurezza",
    "- Segnaletica dei cantieri stradali",
    "- Il nuovo approccio",
    "- Le Direttive di prodotto",
    "- Norme armonizzate",
    "- Valutazione rischio macchine",
    "- Decreto 758 sanzioni (cenni)",
    "- DPI connessi ai rischi specifici di mansione",
    "- Check list di verifica di cantiere",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "formazione-generale-specifica-rischio-basso-8h": [
    "FORMAZIONE GENERALE",
    "concetti di pericolo, rischio e danno, prevenzione e protezione",
    "organizzazione della prevenzione aziendale e il sistema di partecipazione dei lavoratori e dei loro rappresentanti previsto dal D. Lgs. 81 del 2008;",
    "diritti, doveri e sanzioni per i vari soggetti aziendali;",
    "organi di vigilanza, controllo e assistenza",
    "FORMAZIONE SPECIFICA",
    "rischi infortunistici;",
    "meccanici generali;",
    "elettrici generali;",
    "macchine;",
    "attrezzature;",
    "lavori in quota  e cadute dall’alto;",
    "rischi da esplosione;",
    "rischi connessi all’impiego di agenti chimici, cancerogeni e mutageni;",
    "rischi biologici;",
    "rischi fisici (Rumore, Vibrazione, Radiazioni, Microclima e illuminazione, campi elettromagnetici, ecc. );",
    "videoterminali;",
    "DPI;",
    "ambienti di lavoro;",
    "rischi da fattori psicosociali e stress lavoro-correlato;",
    "movimentazione manuale carichi;",
    "movimentazione merci (apparecchi di sollevamento, mezzi trasporto);",
    "segnaletica;",
    "emergenze,",
    "le procedure di sicurezza con riferimento al profilo di rischio specifico;",
    "procedure esodo e incendi;",
    "procedure organizzative per il primo soccorso;",
    "incidenti e infortuni mancati;",
    "differenza di età, genere, provenienza geografica e parità di genere;",
    "violenza e molestie sui luighi di lavoro;",
    "altri Rischi.",
    "Verifca finale di apprendimento"
  ],
  "aggiornamento-aspp-20h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Aggiornamento normativo:",
    "Accordi Stato Regioni - Formazione",
    "Decreto 81 - Parte Generale",
    "Aggiornamento giuridico:",
    "Le Rappresentanze",
    "Ruolo Enti Paritetici",
    "Organi di Vigilanza",
    "I Rischi e il Servizio di Prevenzione e Protezione:",
    "SPP organizzare servizio interno ed esterno",
    "Art. 28  29 La Valutazione dei Rischi",
    "DUVRI - 31:56",
    "Procedure ditte esterne",
    "Appalti, Cantieri Edili, Macchinari e Attrezzature:",
    "Titolo IV - Cantieri",
    "Spazi Confinati",
    "Macchine operatrici pesanti",
    "Attrezzature di lavoro",
    "Dispositivi Protezione Individuale",
    "Titolo V - Segnaletica sicurezza",
    "Gestione delle Emergenze:",
    "Piano emergenze e procedure",
    "Modelli Organizzativi e Sistemi:",
    "DLGS 231",
    "SGSL - Sistema di Gestione della Sicurezza sul Lavoro",
    "UNI ISO 45001",
    "Teoria dei giochi",
    "Lavori Elettrici:",
    "PES PAV PEI",
    "La Comunicazione:",
    "La comunicazione non verbale",
    "Sistema delle relazioni e della Comunicazione",
    "Infortuni e malattie:",
    "Infortunio e malattia",
    "I Costi della sicurezza:",
    "Valutazione dei costi",
    "Valutazione dei costi della non sicurezza",
    "La Responsabilità dell'RSPP",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "formatori-40h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Alcuni richiami della legislazione in materia di Titolo IV – D.lgs 81/2008",
    "- La definizione di “cantiere”: giurisprudenza",
    "- L’Impresa affidataria: obblighi di verifica nei cantieri",
    "- Lo “Statuto funzionale del CSE”: strategie operative e responsabilità",
    "- Il ruolo e la funzione del R.U.P negli appalti pubblici",
    "- Giurisprudenza commentata",
    "- La definizione di «comunicazione»",
    "- Il ruolo dei «bisogni» e la piramide di Maslow",
    "- I «canali» della comunicazione",
    "- Gli «assiomi» della comunicazione",
    "- Comunicazione efficace e lavoro: assertività e gestione dei conflitti",
    "- Principali disposizioni legislative e normative",
    "- Effetti dell’elettricità sul corpo umano e sistemi di prevenzione e protezione",
    "- Valutazione dei rischi (cenni su POS e PSC)",
    "- MMC",
    "- Rischi fisici",
    "- Rischi chimici e biologici",
    "- Il metodo B-BS",
    "- La scienza del comportamento: principi fondamentali",
    "- Comportamenti di sicurezza più difficili da adottare",
    "- Attrezzatura e DPI per lavori elettrici",
    "- Valutazione dei rischi e delle condizioni ambientali",
    "- Preparazione dei lavori elettrici",
    "- Lavoro su impianti",
    "- Analizzare le motivazioni dei comportamenti: il metodo «pic-nic»",
    "- Orientare i comportamenti: schemi di rinforzo e feed-back",
    "- L’applicazione del modello in una situazione reale",
    "- Cenni di prevenzione incendi",
    "- Mezzi di estinzione utilizzabili in cantiere",
    "- Ruoli e profili professionali",
    "- Comunicazioni e documentazione per lavori elettrici",
    "- Lavori fuori tensione",
    "- Lavori sotto tensione in bassa tensione",
    "- Movimento terra, scavi e rischio di seppellimento",
    "- Rischio di annegamento",
    "- Lavori in elevazione e rischi di caduta nel vuoto e taglio di alberi",
    "- Fase operativa del cantiere",
    "- Mezzi di estinzione",
    "- Fase latente non operativa del cantiere",
    "- Lavori in prossimità di parti attive",
    "- Lavori non elettrici",
    "- Segnaletica di sicurezza",
    "- Segnaletica dei cantieri stradali",
    "- Il nuovo approccio",
    "- Le Direttive di prodotto",
    "- Norme armonizzate",
    "- Valutazione rischio macchine",
    "- Decreto 758 sanzioni (cenni)",
    "- DPI connessi ai rischi specifici di mansione",
    "- Check list di verifica di cantiere",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "datore-di-lavoro-16h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "MODULO 1 - GIURIDICO NORMATIVO",
    "Il sistema legislativo in materia di salute e sicurezza dei lavoratori. L’identificazione e il ruolo del datore di lavoro in relazione al contesto organizzativo. I soggetti del sistema di prevenzione aziendale secondo il d.lgs. n. 81/2008: compiti, obblighi, responsabilità e tutela assicurativa. La delega di funzioni: condizioni e limiti. La responsabilità civile e penale del datore di lavoro. La responsabilità amministrativa ai sensi del d.lgs. n. 231/2001 nel settore privato. Prevenzione della violenza delle molestie sul luogo di lavoro (Documento ILO C 190 Convenzione sull’eliminazione della violenza e delle molestie nel mondo del lavoro). Inserimento di lavoratori disabili (riferimento al d.lgs. 213/2003 (art. 3, c. 3 bis), DL 76/2013 (art. 9, c. 4-ter) convertito con L. 99/2013). I ruoli delle ASL, INL, VVF e Inail. Gli organi di vigilanza e le procedure ispettive.",
    "MODULO 2 - ORGANIZZAZIONE E GESTIONE DELLA SSL",
    "Le misure organizzative e gestionali di tutela ai sensi di quanto previsto dagli art.li 15 e art. 30 del d.lgs. n. 81/2008:",
    "a.   rispetto degli standard tecnico- strutturali di legge relativi a attrezzature, impianti, luoghi di lavoro, agenti chimici, fisici e biologici; con l’acquisizione della relativa documentazione e certificazioni obbligatorie di legge.",
    "Valutazione dei rischi predisposizione delle misure di prevenzione e protezione conseguenti con priorità delle misure di protezione collettiva rispetto alle misure di protezione individuale, ivi compresi quelli riguardanti gruppi di lavoratori esposti a rischi particolari, tra cui anche quelli collegati allo stress lavoro- correlato, secondo i contenuti dell'accordo europeo dell'8 ottobre 2004, e quelli riguardanti le lavoratrici in stato di gravidanza, secondo quanto previsto dal decreto legislativo 26 marzo 2001, n. 151, nonché quelli connessi alle differenze di genere, all'età.",
    "b.   La gestione del rischio interferenziale e il DUVRI",
    "c.   organizzazione e gestione delle emergenze, del primo soccorso, degli appalti, delle riunioni periodiche di sicurezza;",
    "d.   sorveglianza sanitaria;",
    "e.   informazione, formazione, partecipazione e consultazione di tutti i soggetti ai sensi del D.lgs. 81/08;",
    "f.   vigilanza con riferimento al rispetto delle procedure e delle istruzioni di lavoro in sicurezza da parte dei lavoratori e alle periodiche verifiche dell’applicazione e dell’efficacia delle procedure adottate.",
    "·    Modelli di organizzazione e gestione di tipo volontario",
    "·    Costi della mancata sicurezza e benefici della sicurezza",
    "·    Tecniche e strumenti di comunicazione e informazione",
    "TEST DI VERIFICA FINALE"
  ],
  "osa-rischio-elevato-8h": [
    "Personale operante all'interno delle cucine,mense, centri cottura,ristoranti,pizzerie,rosticcerie,paninoteche  e similari;addetti alla preparazione in bar,tavola    calda,gastronomie; addetti  presso stabilimenti ed esercizi di lavorazione delle carni e del pesce; addetti presso stabilimenti di produzione  alimenti a base di uova, gastronomici e dolciari, addetti alla lavorazione di prodotti da forno; addetti alla preparazione e manipolazione di prodotti dietetici,per la prima infanzia,baby foods e destinati da un'alimentazione particolare;addetti alla  lavorazione del latte e dei prodotti caseari,responsabili dell'industria alimentare, nonché personale con responsabilità di sorveglianza, gestione di settore del processo delle medesime attività. Valevole in tutte le regioni Italiane ed accreditato in Regione Calabria",
    "Modulo Unico:",
    "Principali norme in materia di alimenti;",
    "Decreto Legislativo 193/07;",
    "Sistema sanzionatorio;",
    "Tracciabilità e rintracciabilità degli alimenti;",
    "Sicurezza e qualità alimentare;",
    "La contaminazione alimentare;",
    "Malattie a trasmissione alimentare;",
    "Sistema HACCP;",
    "Principi base del sistema HACCP;",
    "Finalità e contenuto del manuale di autocontrollo;",
    "Diagramma di flusso;",
    "Albero delle decisioni;",
    "Sistema di monitoraggio HACCP e azioni correttive;",
    "Verifiche ispettive;",
    "Norme per la conservazione del prodotto;",
    "Norme di buona prassi igienica;",
    "Detergenza e disinfezione;",
    "Igiene del personale;",
    "Lavorazione e manipolazione degli alimenti;",
    "Rischio celiachia;",
    "Di cui: 8 ore e-learning con esame finale."
  ],
  "aggiornamento-osa-4h": [
    "Corso di Aggiornamento per personale operante all'interno delle cucine, mense, centri cottura, ristoranti, pizzerie, rosticcerie, paninoteche  e similari; addetti alla preparazione in bar, tavola    calda, gastronomie; addetti  presso stabilimenti ed esercizi di lavorazione delle carni e del pesce; addetti presso stabilimenti di produzione  alimenti a base di uova, gastronomici e dolciari, addetti alla lavorazione di prodotti da forno; addetti alla preparazione e manipolazione di prodotti dietetici, per la prima infanzia, baby foods e destinati da un'alimentazione particolare; addetti alla  lavorazione del latte e dei prodotti caseari, responsabili dell'industria alimentare, nonché personale con responsabilità di sorveglianza, gestione di settore del processo delle medesime attività. Valevole in tutte le regioni Italiane ed accreditato in Regione Calabria",
    "Modulo Unico:",
    "Principali norme in materia di alimenti",
    "Decreto legislativo 193_07",
    "Sistema Sanzionatorio",
    "La Contaminazione Alimentare",
    "Malattie a trasmissione alimentare",
    "Norme per la conservazione del prodotto",
    "Norme di buona prassi igienica",
    "Detergenza e disinfezione",
    "Tracciabilità Igiene del Personale",
    "Sicurezza e qualità alimentare",
    "Lavorazione e manipolazione degli alimenti Il Sistema HACCP",
    "Principi base del sistema HACCP",
    "Fin. e contenuto del man. di autocontrollo",
    "Diagramma di flusso",
    "Albero delle decisioni",
    "Azioni correttive",
    "Verifiche Ispettive",
    "Allergeni intolleranze rischio celiachia",
    "Di cui: 4 ore e-learning con test di verifica finale."
  ],
  "osa-rischio-medio-6h": [
    "Personale addetto che non manipola direttamente alimenti, operante in attività del settore alimentare quali, a titolo esemplificativo e non esaustivo:",
    "addetti alla vendita, somministrazione e distribuzione di alimenti e bevande confezionati o non confezionati,",
    "personale di bar, pub, esercizi di somministrazione, tavole calde e attività similari con mansioni non direttamente coinvolte nella preparazione degli alimenti,",
    "addetti al trasporto, stoccaggio, magazzinaggio e logistica degli alimenti,",
    "personale di supporto operante in cucine, mense, centri cottura, ristoranti e strutture analoghe,",
    "personale addetto alle pulizie e sanificazione degli ambienti e delle attrezzature alimentari,",
    "personale amministrativo o di servizio che opera a contatto indiretto con gli alimenti o con le aree di produzione.",
    "Contenuti formativi principali:",
    "Il corso fornisce le conoscenze di base in materia di igiene e sicurezza alimentare, con particolare riferimento a:",
    "principi generali dell’HACCP e della normativa vigente in materia di sicurezza alimentare;",
    "nozioni fondamentali di igiene personale, igiene degli ambienti e delle attrezzature;",
    "principali rischi di contaminazione (biologici, chimici e fisici);",
    "corrette prassi igieniche e comportamentali;",
    "nozioni di conservazione, trasporto e stoccaggio degli alimenti;",
    "responsabilità degli operatori del settore alimentare e importanza del rispetto delle procedure aziendali.",
    "TEST DI VERIFICA FINALE",
    "Validità e riconoscimento:",
    "Il corso è valevole su tutto il territorio nazionale, conforme alla normativa vigente in materia di sicurezza alimentare e accreditato dalla Regione Calabria."
  ],
  "modulo-cantieri-dirigenti-6h": [
    "Compiti specifici del datore di lavoro dell’impresa affidataria nei cantieri temporanei e mobili",
    "•    I soggetti definiti dal Titolo IV capo I, e relativi obblighi e responsabilità",
    "•    La redazione dei piani di sicurezza: finalità, tempi e contenuti.",
    "•    Le misure generali di tutela secondo quantoprevisto dall’art. 95 del d.lgs. n. 81/2008",
    "•    Gli obblighi del datore di lavoro, dei dirigenti e dei preposti di cui all’art. 96 del d.lgs. n. 81/2008",
    "•    Il cronoprogramma dei lavori",
    "•    Esempi e analisi di un PSC",
    "•    Esempi e analisi di un POS"
  ],
  "modulo-cantieri-datore-6h": [
    "Compiti specifici del datore di lavoro dell’impresa affidataria nei cantieri temporanei e mobili",
    "•    I soggetti definiti dal Titolo IV capo I, e relativi obblighi e responsabilità",
    "•    La redazione dei piani di sicurezza: finalità, tempi e contenuti.",
    "•    Le misure generali di tutela secondo quantoprevisto dall’art. 95 del d.lgs. n. 81/2008",
    "•    Gli obblighi del datore di lavoro, dei dirigenti e dei preposti di cui all’art. 96 del d.lgs. n. 81/2008",
    "•    Il cronoprogramma dei lavori",
    "•    Esempi e analisi di un PSC",
    "•    Esempi e analisi di un POS"
  ],
  "aggiornamento-rspp-datore-lavoro-8h": [
    "Il processo di valutazione: criteri e metodologie",
    "i criteri e gli strumenti per l’individuazione e la valutazione dei rischi",
    "struttura e contenuti del documento di valutazione dei rischi",
    "l’analisi degli infortuni mancati e delle modalità di accadimento degli stessi;",
    "la gestione della documentazione tecnico amministrativa;",
    "le procedure semplificate per la redazione della valutazione del rischio.",
    "I fattori di rischio e misure di prevenzione e protezione",
    "a) fattori di rischio relativi a:",
    "•    luoghi di lavoro;",
    "•    attrezzature di lavoro;",
    "•    movimentazione manuale dei carichi",
    "•    VDT;",
    "•    agenti fisici;",
    "•    sostanze pericolose;",
    "•    agenti biologici;",
    "•    atmosfere esplosive;",
    "•        stress lavoro-correlato e fattori psicosociali;",
    "•        rischi ricollegabili al genere, all’età e alla provenienza da altri paesi;",
    "c)    misure tecniche, organizzative e procedurali di prevenzione e protezione;",
    "d)    dispositivi di protezione individuale;",
    "e)    segnaletica di sicurezza",
    "Esercitazione",
    "Predisposizione di un documento di valutazione dei rischi per un caso concreto riferito al settore ATECO di riferimento"
  ],
  "formazione-generale-lavoratori-4h-eng": [
    "FORMAZIONE GENERALE",
    "concetti di pericolo, rischio e danno, prevenzione e protezione",
    "organizzazione della prevenzione aziendale e il sistema di partecipazione dei lavoratori e dei loro rappresentanti previsto dal D. Lgs. 81 del 2008;",
    "diritti, doveri e sanzioni per i vari soggetti aziendali;",
    "organi di vigilanza, controllo e assistenza"
  ],
  "dirigenti-12h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Il sistema legislativo in materia di salute e sicurezza sul lavoro",
    "I soggetti del sistema di prevenzione aziendale",
    "Compiti, obblighi e responsabilità del dirigente",
    "Delega di funzioni e principio di effettività",
    "Gli organi di vigilanza e le procedure ispettive",
    "Organizzazione del Servizio di Prevenzione e Protezione",
    "Ruolo del RSPP, del Medico Competente, del RLS e del RLST",
    "Modelli di organizzazione e gestione della salute e sicurezza sul lavoro",
    "Sistemi di gestione della salute e sicurezza sul lavoro (SGSL)",
    "Criteri e strumenti per la valutazione dei rischi",
    "Misure tecniche, organizzative e procedurali di prevenzione e protezione",
    "Appalti, contratti d’opera, somministrazione, DUVRI e rischio interferenziale",
    "Organizzazione della prevenzione incendi, primo soccorso e gestione delle emergenze",
    "Sorveglianza sanitaria",
    "Infortuni, malattie professionali e near miss",
    "Informazione, formazione e addestramento",
    "Consultazione e partecipazione dei rappresentanti dei lavoratori",
    "Tecniche di comunicazione, gestione delle relazioni e leadership",
    "Test di Verifica Finale del Corso",
    "Scheda di valutazione per corsi di formazione in materia di sicurezza sul lavoro – modalità FAD asincrona"
  ],
  "responsabile-industria-alimentare": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "Principali norme in materia di igiene e sicurezza alimentare",
    "Decreto Legislativo 193/2007 e sistema sanzionatorio in materia di sicurezza alimentare",
    "Ruolo dell’Operatore del Settore Alimentare e responsabilità aziendali",
    "Il sistema HACCP: definizione, finalità e principi fondamentali",
    "Principi base del sistema di autocontrollo alimentare",
    "Analisi dei pericoli biologici, chimici, fisici e allergenici",
    "Contaminazione alimentare e modalità di prevenzione",
    "Contaminazione crociata e buone pratiche operative",
    "Malattie a trasmissione alimentare e tossinfezioni alimentari",
    "Norme per la conservazione degli alimenti e corretta gestione dei prodotti",
    "Temperature, catena del freddo, congelamento, scongelamento e mantenimento a caldo",
    "Gestione delle non conformità e azioni correttive",
    "Norme di buona prassi igienica",
    "Igiene personale degli operatori alimentaristi",
    "Lavorazione e manipolazione degli alimenti",
    "Pulizia, detergenza, disinfezione e sanificazione di locali, superfici e attrezzature",
    "Piano di pulizia e controllo ambientale",
    "Gestione degli infestanti, dei rifiuti e manutenzione degli ambienti di lavoro",
    "Sicurezza e qualità alimentare",
    "Tracciabilità e rintracciabilità degli alimenti",
    "Ritiro e richiamo dei prodotti alimentari non sicuri",
    "Allergeni alimentari, intolleranze e rischio celiachia",
    "Gestione degli allergeni e corretta informazione al consumatore",
    "Finalità e contenuto del manuale di autocontrollo HACCP",
    "Diagramma di flusso e analisi delle fasi del processo alimentare",
    "Albero delle decisioni e individuazione dei punti critici di controllo",
    "Sistema di monitoraggio HACCP e azioni correttive",
    "Verifiche ispettive, controlli ufficiali e documentazione aziendale",
    "Test di Verifica Finale del Corso",
    "Scheda di valutazione per corsi di formazione in materia di igiene e sicurezza alimentare – modalità FAD asincrona"
  ],
  "formatori-24h": [
    "Gli argomenti trattati nelle lezioni del corso soddisfano la presente articolazione didattica:",
    "- Alcuni richiami della legislazione in materia di Titolo IV – D.lgs 81/2008",
    "- La definizione di “cantiere”: giurisprudenza",
    "- L’Impresa affidataria: obblighi di verifica nei cantieri",
    "- Lo “Statuto funzionale del CSE”: strategie operative e responsabilità",
    "- Il ruolo e la funzione del R.U.P negli appalti pubblici",
    "- Giurisprudenza commentata",
    "- La definizione di «comunicazione»",
    "- Il ruolo dei «bisogni» e la piramide di Maslow",
    "- I «canali» della comunicazione",
    "- Gli «assiomi» della comunicazione",
    "- Comunicazione efficace e lavoro: assertività e gestione dei conflitti",
    "- Principali disposizioni legislative e normative",
    "- Effetti dell’elettricità sul corpo umano e sistemi di prevenzione e protezione",
    "- Valutazione dei rischi (cenni su POS e PSC)",
    "- MMC",
    "- Rischi fisici",
    "- Rischi chimici e biologici",
    "- Il metodo B-BS",
    "- La scienza del comportamento: principi fondamentali",
    "- Comportamenti di sicurezza più difficili da adottare",
    "- Attrezzatura e DPI per lavori elettrici",
    "- Valutazione dei rischi e delle condizioni ambientali",
    "- Preparazione dei lavori elettrici",
    "- Lavoro su impianti",
    "- Analizzare le motivazioni dei comportamenti: il metodo «pic-nic»",
    "- Orientare i comportamenti: schemi di rinforzo e feed-back",
    "- L’applicazione del modello in una situazione reale",
    "- Cenni di prevenzione incendi",
    "- Mezzi di estinzione utilizzabili in cantiere",
    "- Ruoli e profili professionali",
    "- Comunicazioni e documentazione per lavori elettrici",
    "- Lavori fuori tensione",
    "- Lavori sotto tensione in bassa tensione",
    "- Movimento terra, scavi e rischio di seppellimento",
    "- Rischio di annegamento",
    "- Lavori in elevazione e rischi di caduta nel vuoto e taglio di alberi",
    "- Fase operativa del cantiere",
    "- Mezzi di estinzione",
    "- Fase latente non operativa del cantiere",
    "- Lavori in prossimità di parti attive",
    "- Lavori non elettrici",
    "- Segnaletica di sicurezza",
    "- Segnaletica dei cantieri stradali",
    "- Il nuovo approccio",
    "- Le Direttive di prodotto",
    "- Norme armonizzate",
    "- Valutazione rischio macchine",
    "- Decreto 758 sanzioni (cenni)",
    "- DPI connessi ai rischi specifici di mansione",
    "- Check list di verifica di cantiere",
    "Test di Verifica Finale del Corso",
    "SCHEDA DI VALUTAZIONE PER CORSI DI FORMAZIONE IN MATERIA DI SICUREZZA SUL LAVORO - MODALITÀ FAD A-SINCRONA"
  ],
  "aggiornamento-datore-lavoro-6h": [
    "- Novità legislative e circolari applicative recenti, con particolare riferimento all’Accordo Stato-Regioni 2025",
    "- Evoluzione degli obblighi e delle responsabilità del datore di lavoro",
    "- Nozioni giuridiche e tecnico-organizzative aggiornate",
    "- Gestione della prevenzione in azienda e aggiornamento delle procedure interne",
    "- Principali adempimenti documentali",
    "- Strumenti digitali e metodologie utili per la prevenzione",
    "- Comunicazione interna e rapporto con lavoratori, RLS, medico competente e consulenti",
    "Test di verifica finale"
  ]
};
